<template>
  <div class="printme">
    <div class="visibility-hidden">
      <b-row>
        <b-col cols="4">
          <img
            src="../../assets/logo-promart.png"
            style="height: 80px; width: auto"
            alt=""
          />
        </b-col>
        <b-col cols="4">
          <p class="font-weight-500" style="margin-bottom: 0; margin-top: 8%">
            INFORME TÉCNICO
          </p>
        </b-col>
      </b-row>
    </div>

    <b-row>
      <b-col cols="6">
        <b-form-group id="input-group-177" label="Cliente" label-for="input-177">
          <b-form-input
           readonly
            id="input-17"
            v-model="informTech.clientName"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group id="input-group-19" label="Tienda" label-for="input-19">
          <b-form-input
            readonly
            id="input-17"
            v-model="informTech.codeStore"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group id="input-group-19" label="N° OS" label-for="input-19">
          <b-form-input
            readonly
            id="input-17"
            v-model="informTech.numOs"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group
          id="input-group-19"
          label="Fecha de Servicio"
          label-for="input-19"
        >
          <b-form-input
            readonly
            id="input-17"
            v-model="informTech.dateService"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="no-printme">
      <b-col cols="6">
        <b-form-group
          id="input-group-50"
          label="Nombre de Técnico"
          label-for="input-19"
        >
          <b-form-input
            readonly
            id="input-50"
            v-model="informTech.technicianName"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group id="input-group-50" label="Estado" label-for="input-19">
          <b-form-input
            readonly
            id="input-50"
            v-model="informTech.state"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
 
    <b-row class="visibility-hidden">
      <b-col md="12" class="padding-two-bottom">
      <label class="font-weigth-600">Descripción del área </label>
        <p class="text-medium padding-two-bottom">
          
          {{ informTech.observationsArea || '' }}  
         
        </p>
      </b-col>
    </b-row>
  
    <b-row class="visibility-hidden">
      <b-col md="12" class="padding-two-bottom">
        <label class="font-weigth-600">Descripción del servicio</label>
        <p class="text-medium padding-two-bottom">
           {{ informTech.detailServices || '' }}
        </p>
      </b-col>
    </b-row> 
    <b-row>
      <b-col md="12" class="padding-two-bottom">
        <label class="font-weigth-600"> Detalle de los servicios requeridos</label>
      </b-col>
    </b-row>
    <b-row v-show="informTech.serviceMaterial.length">
      <b-col md="12">
        <b-table
          
          :items="servicesFiltered"
          :fields="fieldServices"
          striped
        >
          
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="padding-two-bottom">
        <span class="font-weigth-600" > Detalle de trabajos especiales</span>
      </b-col>
    </b-row>
    
    <b-row >
      <b-col md="12" class="padding-two-bottom">
        <label class="font-weight-600" >Detalle de los materiales requeridos</label>
        <p v-for="(job, index) in informTech.specialJob" :key="index">
            {{ job.description }}
        </p>
        
      </b-col>
    </b-row>
    <b-row v-show="informTech.serviceMaterial.length">
      <b-col md="12">
        <b-table
          
          :items="servicesMaterialFiltered"
          :fields="fieldMaterial"
          striped
        >
          
        </b-table>
      </b-col>
    </b-row>
    


   
    
 
 
    
    <b-row class="visibility-hidden">
      <b-col md="12" class="padding-two-bottom">
        <label class="font-weight-600">Observaciones adicionales</label>
        <p>{{ informTech.observationsAdditional }}</p>
      </b-col>
    </b-row>
    <b-row class="visibility-hidden">
      <b-col md="12" class="padding-two-bottom">
        <label class="font-weight-600">Tiempo aproximado de ejecución</label>
        <p>{{ informTech.timeExecution }}</p>
      </b-col>
    </b-row>
    <b-row class="visibility-hidden">
      <b-col md="12">
        <p>Términos y condiciones</p>
        <ul>
          <li>
            Los servicios a realizar serán unicamente los que se encuentren dentro del presente documento.
          </li>
          <li>
            La vigencia de la visita técnica es 30 días calendario contados desde la emisión del presente documento.
          </li>
          <li>
           En caso se requieran trabajos adicionales al contratado inicialmente, éstos se presupuestarán de manera independiente.
          </li>
        </ul>

       
      </b-col>
    </b-row>
    
  
  
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import { getPhotosRoute } from "../../assets/js/common";
export default {
  name: "InformeTecnico",
  data() {
    return {
      enableDescription: true,
      slide: 0,
      photosRoute: [],
      dismissSecs: 10,
      dismissCountDown: 0,
      msg: "",
      emailUser: "",
      currentPage: 1,
      perPage: 10,
      selectedOption: null,
      options: [
        { value: "A", text: "SERVICIO" },
        { value: "B", text: "MATERIAL" },
      ],
      fieldMaterial: [
        
        { key: "description", label: "Descripción" },
        { key: "quantity", label: "Cantidad" },
        
        { key: "actions", label: "" },
      ],
      fieldServices: [
        { key: "sku", label: "Sku" },
        { key: "description", label: "Descripción" },
        { key: "quantity", label: "Cantidad" },
        
        { key: "actions", label: "" },
      ],
      fieldJob: [
        { key: "description", label: "Descripción" },
        { key: "actions", label: "" },
      ],
      skuService: "",
      skuServiceDes: "",
      quantitySku: "",
      quantity: "",
      detailJob: "",
      reportClient: "",
      inform: "",
      recomendation: "",
      maxLength: 500,
      variant: "",
      messageAlert: "",
      informTech: {
        idRoute: 0,
        codeStore: "",
        dniClient: "",
        dniTechnical: "",
        numOs: "",
        observationsArea: "",
        detailServices: "",
        observationsAdditional: "",
        dateService: "",
        id: "",
        serviceMaterial: [],
        specialJob: [],
      },
    };
  },

  props: {
    idTechInform: {
      type: Number,
    },
  },
  created() {
    console.log('testing')
    this.getInformTech();
  },
  computed: {
    ...mapState("module", ["username", "perfil","token"]),
   servicesFiltered() {
      return this.informTech.serviceMaterial.filter((i) => i.deleted == false&&i.typeProduct=="SERVICIO");
    },
    servicesMaterialFiltered() {
      return this.informTech.serviceMaterial.filter((i) => i.deleted == false&&i.typeProduct=="MATERIAL");
    },
  },
  methods: {
    
    print() {
      window.print();
    },
    
    async getInformTech() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ORDERS_CORE_BASE + "/tvr/" + this.idTechInform
        );

        const specialJob = response.data.specialJob.map((c) => ({
          idTvr: this.idTechInform,
          description: c.description,
          quantity: c.quantity,
          deleted: false,
          id: c.id,
        }));
        const serviceMaterial = response.data.serviceMaterial.map((c) => ({
          idTvr: this.idTechInform,
          description: c.description,
          quantity: c.quantity,
          sku: c.sku,
          typeProduct: c.typeProduct,
          deleted: false,
          id: c.id,
        }));
        this.informTech = response.data;
        this.informTech.specialJob = specialJob;
        this.informTech.serviceMaterial = serviceMaterial;
        if (response.data.idRoute)
          this.photosRoute = await getPhotosRoute(response.data.idRoute);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>

.font-bolder {
  font-weight: bold;
  font-size: 23px;
  padding: 0;
  background: transparent;
  border-color: transparent;
}
::v-deep .b-table thead {
  background: rgb(254, 123, 1);
  color: black !important;
  font-weight: 400 !important;
}
::v-deep .b-table thead th {
  font-weight: 400 !important;
}

</style>
